import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';

import { useAuth } from '@/auth/useAuth';
import { useUserSession } from '@/hooks/useUserSession';

export function ProfileMenu() {
  const { logout } = useAuth();
  const { email } = useUserSession();

  return (
    <Menu as="div" className="relative">
      <MenuButton className="relative flex rounded-full focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#274483] cursor-pointer">
        <span className="absolute -inset-1.5" />
        <span className="sr-only">{'Open user menu'}</span>
        <div
          className="size-6 rounded-full relative shrink-0 flex items-center justify-center text-[11px] font-bold text-white transition-transform hover:scale-105 cursor-pointer"
          style={{ background: '#4A6BAD' }}
        >
          {email.charAt(0).toUpperCase()}
        </div>
      </MenuButton>

      <MenuItems
        transition
        className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg outline outline-black/5 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in cursor-pointer"
      >
        <MenuItem>
          <a
            onClick={logout}
            className="block px-4 py-2 text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden"
          >
            {'Sign out'}
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
